/* @flow */
import React, { Component } from 'react';

import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Container from 'components/Container.jsx';

import UnauthenticatedView from './UnauthenticatedView.jsx';

import './styles/AuthenticationView.scss';

export class AuthenticationView extends Component {
  props: {
    size: 'xsmall' | 'small' | 'medium' | 'large',
    children?: any,
  }

  static defaultProps = {
    size: 'xsmall',
  }

  render() {
    const { size, ...props } = this.props;
    return (
      <UnauthenticatedView {...props}>
        <Container size={size}>
          <Box className="AuthenticationView-box">
            <BoxBody>
              {this.props.children}
            </BoxBody>
          </Box>
        </Container>
      </UnauthenticatedView>
    );
  }
}

export default AuthenticationView;



// WEBPACK FOOTER //
// ./src/auth/components/AuthenticationView.jsx